/**
 * POST application/x-www-form-urlencoded body to a Google Form formResponse URL.
 */
export function postGoogleFormResponse(
  formId: string,
  data: Record<string, string>,
): Promise<string> {
  const body = new URLSearchParams();
  Object.entries(data).forEach(([key, value]) => {
    body.append(key, value.trim());
  });

  const url = `https://docs.google.com/forms/d/e/${formId}/formResponse`;
  const headers = new Headers();
  headers.append("Content-Type", "application/x-www-form-urlencoded");
  headers.append("access-control-allow-origin", "*");

  return fetch(url, {
    method: "POST",
    body,
    headers,
    mode: "no-cors",
  }).then((response) => response.text());
}

/** Maps Contentful/Google field ids to `entry.<id>` keys for the POST body. */
export function toGoogleFormEntryPayload(
  data: Record<string, string>,
): Record<string, string> {
  return Object.keys(data).reduce(
    (acc, key) => {
      return {
        ...acc,
        [`entry.${key}`]: data[key]?.trim() ?? "",
      };
    },
    {} as Record<string, string>,
  );
}
